import * as Sentry from '@sentry/react'
import type { PostHogBlockedReason } from './checkPostHogReachability'

let hasReportedBlockedThisSession = false

export function resetPostHogBlockedSessionReport(): void {
  hasReportedBlockedThisSession = false
}

/**
 * Alerts the team via Sentry. PostHog itself cannot carry this event — the
 * host is the thing that's blocked (NOD-3773). Fingerprinted so Brave shields
 * and corporate firewalls collapse into one issue.
 */
export function reportPostHogHostBlocked(details: {
  host: string
  reason: PostHogBlockedReason
}): void {
  if (hasReportedBlockedThisSession) return
  hasReportedBlockedThisSession = true

  Sentry.withScope((scope) => {
    scope.setLevel('info')
    scope.setTag('posthog_blocked', 'true')
    scope.setFingerprint(['posthog-host-blocked'])
    scope.setExtra('host', details.host)
    scope.setExtra('reason', details.reason)
    scope.setExtra('userAgent', navigator.userAgent)
    Sentry.captureMessage('PostHog host is blocked')
  })
}
